import { useToggle } from "../../hooks/useToggle.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/ShowHideContent/index.tsx
function ShowHideContent({ children, label }) {
	const [showHide, toggleShowHide] = useToggle(false);
	return /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
		className: "pl-xxs bg-surface-strong w-full hover:cursor-pointer",
		onClick: toggleShowHide,
		children: label
	}), showHide && children] });
}
//#endregion
export { ShowHideContent };

//# sourceMappingURL=index.js.map